import { render, staticRenderFns } from "./add-edit-quiz.vue?vue&type=template&id=3a4df3d1&scoped=true&"
import script from "./add-edit-quiz.vue?vue&type=script&lang=js&"
export * from "./add-edit-quiz.vue?vue&type=script&lang=js&"
import style0 from "./add-edit-quiz.vue?vue&type=style&index=0&id=3a4df3d1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4df3d1",
  null
  
)

component.options.__file = "add-edit-quiz.vue"
export default component.exports